// extracted by mini-css-extract-plugin
module.exports = {"hide":"ShowMoreText_hide__86Kzl"};